// BUSINESS DESK — clients : liste, recherche, création/édition.
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { deskApi } from "./deskApi";

const EMPTY = { name: "", phone: "", email: "", address: "", country: "Côte d'Ivoire", company_name: "", tax_identifier: "" };

export default function DeskCustomers() {
  const [q, setQ] = useState("");
  const [customers, setCustomers] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => {
    deskApi(`/customers?q=${encodeURIComponent(q)}`).then((d) => setCustomers(d.customers)).catch(() => {});
  }, [q]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  const save = async () => {
    try {
      if (editing.customer_id) {
        await deskApi(`/customers/${editing.customer_id}`, { method: "PUT", body: { ...editing, customer_id: undefined } });
      } else {
        await deskApi("/customers", { method: "POST", body: editing });
      }
      toast.success("Client enregistré ✓");
      setEditing(null);
      load();
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div data-testid="desk-customers">
      <div className="desk-field">
        <input className="desk-input" data-testid="desk-customers-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔍 Rechercher…" />
      </div>
      <button className="desk-btn desk-btn-gold" style={{ marginTop: 12 }} data-testid="desk-customers-add-btn" onClick={() => setEditing({ ...EMPTY })}>
        ➕ Nouveau client
      </button>

      {customers.map((c) => (
        <div key={c.customer_id} className="desk-doc-card" style={{ cursor: "pointer" }} data-testid={`desk-customer-card-${c.customer_id}`} onClick={() => setEditing({ ...EMPTY, ...c })}>
          <div className="desk-doc-number">{c.name}{c.company_name ? ` — ${c.company_name}` : ""}</div>
          <div className="desk-doc-client">{[c.phone, c.address, c.country].filter(Boolean).join(" · ")}</div>
        </div>
      ))}
      {customers.length === 0 && <div className="desk-empty">Aucun client.</div>}

      {editing && (
        <div className="desk-modal-overlay" onClick={() => setEditing(null)}>
          <div className="desk-modal" onClick={(e) => e.stopPropagation()} data-testid="desk-customer-edit-modal">
            <h3>{editing.customer_id ? "Modifier le client" : "Nouveau client"}</h3>
            <div className="desk-field"><label>Nom complet *</label>
              <input className="desk-input" data-testid="desk-cust-name-input" value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} /></div>
            <div className="desk-row2">
              <div className="desk-field"><label>Téléphone</label>
                <input className="desk-input" value={editing.phone} onChange={(e) => setEditing({ ...editing, phone: e.target.value })} /></div>
              <div className="desk-field"><label>Pays</label>
                <input className="desk-input" value={editing.country} onChange={(e) => setEditing({ ...editing, country: e.target.value })} /></div>
            </div>
            <div className="desk-field"><label>Email</label>
              <input className="desk-input" value={editing.email} onChange={(e) => setEditing({ ...editing, email: e.target.value })} /></div>
            <div className="desk-field"><label>Adresse</label>
              <input className="desk-input" value={editing.address} onChange={(e) => setEditing({ ...editing, address: e.target.value })} /></div>
            <div className="desk-row2">
              <div className="desk-field"><label>Société</label>
                <input className="desk-input" value={editing.company_name} onChange={(e) => setEditing({ ...editing, company_name: e.target.value })} /></div>
              <div className="desk-field"><label>N° fiscal (optionnel)</label>
                <input className="desk-input" value={editing.tax_identifier} onChange={(e) => setEditing({ ...editing, tax_identifier: e.target.value })} /></div>
            </div>
            <button className="desk-btn desk-btn-gold" style={{ marginTop: 16 }} data-testid="desk-cust-save-btn" disabled={!editing.name.trim()} onClick={save}>Enregistrer</button>
            <button className="desk-btn desk-btn-outline" style={{ marginTop: 8 }} onClick={() => setEditing(null)}>Fermer</button>
          </div>
        </div>
      )}
    </div>
  );
}
